import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import Firebase, { FirebaseContext } from "./firebase";

const startApp = () => {
  ReactDOM.render(
    <FirebaseContext.Provider value={new Firebase()}>
      <App />
    </FirebaseContext.Provider>,
    document.getElementById("root")
  );
  serviceWorker.unregister();
};
if (window.cordova) {
  document.addEventListener("deviceready", startApp, false);
} else {
  startApp();
}
